export const FAQ_URL = "https://perkspot-travel-faq.hopper.com/";
export const PRIVACY_POLICY_URL = "https://hopper.com/legal/privacy-policy";
export const TERMS_OF_USE_URL = "https://hopper.com/legal/terms-and-conditions";
export const LOWEST_PRICE_RULE_URL =
  "https://perkspot-travel-faq.hopper.com/en_us/how-does-the-perkspot-low-rate-promise-work-BkIGn3deZg";
export const REWARDS_POINTS_FAQ_URL =
  "https://support.perkspot.com/hc/en-us/sections/360010163872-Rewards-Points-FAQs";
export const SUPPORT_URL = "https://support.perkspot.com/hc/en-us";
export const SUPPORT_PHONE = "+18334510677";
